"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TEXT_SIZE;
(function (TEXT_SIZE) {
    TEXT_SIZE["s"] = "s";
    TEXT_SIZE["m"] = "m";
    TEXT_SIZE["l"] = "l";
    TEXT_SIZE["xl"] = "xl";
})(TEXT_SIZE = exports.TEXT_SIZE || (exports.TEXT_SIZE = {}));
var TEXT_VIEW;
(function (TEXT_VIEW) {
    TEXT_VIEW["primary"] = "primary";
    TEXT_VIEW["secondary"] = "secondary";
    TEXT_VIEW["accent"] = "accent";
    TEXT_VIEW["light"] = "light";
    TEXT_VIEW["link"] = "link";
    TEXT_VIEW["inherit"] = "inherit";
    TEXT_VIEW["affect"] = "affect";
    TEXT_VIEW["error"] = "error";
})(TEXT_VIEW = exports.TEXT_VIEW || (exports.TEXT_VIEW = {}));
var TEXT_WEIGHT;
(function (TEXT_WEIGHT) {
    TEXT_WEIGHT["lighter"] = "lighter";
    TEXT_WEIGHT["normal"] = "normal";
    TEXT_WEIGHT["semiBold"] = "semiBold";
    TEXT_WEIGHT["bold"] = "bold";
})(TEXT_WEIGHT = exports.TEXT_WEIGHT || (exports.TEXT_WEIGHT = {}));
var TEXT_ALIGN;
(function (TEXT_ALIGN) {
    TEXT_ALIGN["left"] = "left";
    TEXT_ALIGN["center"] = "center";
    TEXT_ALIGN["right"] = "right";
})(TEXT_ALIGN = exports.TEXT_ALIGN || (exports.TEXT_ALIGN = {}));
var TEXT_WHITE_SPACE;
(function (TEXT_WHITE_SPACE) {
    TEXT_WHITE_SPACE["normal"] = "normal";
    TEXT_WHITE_SPACE["nowrap"] = "nowrap";
    TEXT_WHITE_SPACE["pre"] = "pre";
    TEXT_WHITE_SPACE["preWrap"] = "pre-wrap";
    TEXT_WHITE_SPACE["preLine"] = "pre-line";
})(TEXT_WHITE_SPACE = exports.TEXT_WHITE_SPACE || (exports.TEXT_WHITE_SPACE = {}));
//# sourceMappingURL=types.js.map